import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "grapesjs/dist/css/grapes.min.css";
import "../css/editor.scss";
import "../css/listOfSlides.scss";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import getGrapeJsEditor from "../utils/editorUtils/getGrapeJsEditor";
import { filterCssObjForPerDimension } from "../utils/editorUtils/responsiveCssManager";
import CustomModal from "../components/CustomModal";

import CircularProgressBar from "../utils/CircularProgressBar";
import { updatSlideData, PDFPreview } from "../services/apis";
import SlideSwapperLeftPanel from "../components/SlideSwapperLeftPanel";
import ParentSlideNavigation from "../components/Slide/ParentSlideNavigation";
import ExportTemplate from "../components/ExportTemplate";
import {
  getSlideDetailsById,
  // getSlideDetails,
  geteDetailByID,
  getBrandDetails,
  getMarketDetails,
  getCampaignDetails,
  // getImcToken,
  // imcSearchContentModules,
  getContentModuleCardinfo,
  getVeevaLinkedModulesListByid,
  getDeckTraceabilityMatrix,
  // getAllScripts,
} from "../services/apis";

// import { getEdtailData } from "../utils";

import SlideIndex from "../components/Slide/SlideIndex";
import SlideNextAndPrevious from "../components/Slide/SlideNextAndPrevious";
import ValueContext from "../utils/contextAPI/contextAPI";
import SubSlide from "../components/Slide/SubSlide";
// import { IPADWIDTH } from "../utils/constants";
import PreviewModal from "../components/Preview/Preview";
// import VeevaContentModal from "../components/ContentModules/VeevaContentModules";

import { inParent, lastChild } from "../components/Slide/ChildSlideCrND";
import { ExportDeckToMail } from "../services/apis";
import MLRPDF from "../components/MLRPDF/MLRPDF";
import NextContentModuleModal from "../components/ContentModules/NextContentModuleModal";
import { instance } from "../services/axiosConfig";
import { keycloak } from "../services/keycloak";
// import { useKeycloak } from "@react-keycloak/web";
import "../css/EditorWrapper.scss";
import SaveChangesNewIcon from "../images/save-change-image.svg";
import FlowCreatorIcon from "../images/flowCreatorIcon.svg";
import GroupNewIcon from "../images/GroupNewIcon.svg";

import DetailsInformationsModal from "../components/DetailsInformationsModal";
import RunValidationChecksModal from "../components/modals/RunValidationChecksModal/RunValidationChecksModal";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import CustomTooltip from "../components/Tooltip/Tooltip";
import TopPanelIcons from "../components/TopPanelIcons";
import RevertBackSmartTemp from "../components/SmartTemplate/RevertBackSmartTemp";
import ReferenceWarning from "../components/SmartTemplate/ReferenceWarning";

import CloneSlideTemplate from "../components/Slide/CloneSlideTemplate";
import FontUploadLayout from "../components/FontUpload/FontUpload";
import ClearSlide from "../components/Slide/ClearSlide";
import { UploadDocument } from "../components/UploadDocument/UploadDocument";
import LeftIcon from "../images/new-slide-left-icon.svg";
import RightIcon from "../images/new-slide-right-icon.svg";
import SharedResource from "../components/SharedResource/SharedResource";
import EditSharedIcon from "../images/edit-shared-resource-icon.svg";
import UndoNewIcon from "../images/Undo-New-Icon.svg";
import RedoNewIcon from "../images/Redo-New-Icon.svg";
import NewCodeEditor from "../components/CodeEditor/NewCodeEditor";
import Module from "../components/ContentModules/ModuleWindow/Module";
import LeftContentPanel from "../components/LeftContentPanel/LeftContentPanel";
import PresentationStatus from "../components/PresentationStatus/PresentationStatus";
import { toggleLeftPanel } from "../utils/editorUtils/commonFunctions";
import MediaTab from "../components/ImageMedia/MediaTab";
import VideoMediaTab from "../components/VideoMedia/VideoMediaTab";
import { emitter, MediaTabFunction } from "../utils/editorUtils/editorUtils";
import {
  showErrorToast,
  showSuccessToast,
} from "../components/toastComponent/ToastComponent";
import SwitchClassicModular from "../components/SwitchClassicModular";
import { template } from "../utils/constants";
import NewPreviewModal from "../components/Preview/NewPreviewModal";
import { syncSelectedModuleUsedFromCanvas } from "../utils/editorUtils/syncSelectedModuleUsedFromCanvas";

const Editor = () => {
  const { pageId } = useParams();
  const appData = useContext(ValueContext);
  const [editor, setEditor] = useState(null);
  const [showAllSlides, setShowAllSlides] = useState(false);
  const showAllSlidesRef = useRef(showAllSlides);

  const [slideCount, setSlideCount] = useState(1);
  const [currentSlide, setCurrentSlide] = useState({});

  const [slideID, setSlideID] = useState([]);
  const [slideNameCount, setSlideNameCount] = useState(0);
  const [showEnterKeyMessageInput, setShowEnterKeyMessageInput] =
    useState(false);
  const [showEnterSlideNameInput, setShowEnterSlideNameInput] = useState(false);
  // const [slideNameValue, setSlideNameValue] = useState("");
  // const [keyMessageValue, setKeyMessageValue] = useState("");

  const [childSlideCount, setChildSlideCount] = useState(0);
  const [toggle, setState] = useState(false);
  const [videoSelected, setVideoSelected] = useState(false);

  const [canvasWidth, setcanvasWidth] = useState(1);
  const [showPreview, setShowPreView] = useState(false);
  const [loading, setLoading] = useState(false);

  const [previewURl, setpreviewURl] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const inputElement = useRef();
  const [searchedText, setSearchedText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const navigate = useNavigate();
  const currentSlideRef = useRef(currentSlide);
  const slideScriptsLoadKeyRef = useRef(null);

  const slideListRef = useRef(slideID);
  const [deckData, setDeckData] = useState({});

  const [brands, setBrands] = useState([]);
  const [market, setMarket] = useState([]);
  const [campaign, setCampaign] = useState([]);
  const [searhModuleModal, setSearhModuleModal] = useState(false);
  const [editModuleSelection, setEditModuleSelection] = useState(false);

  const [campaignName, setCampaignName] = useState("");

  const [saveLoading, setSaveLoading] = useState(false);
  const [mlrPdfLoader, setMlrPdfLoader] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [codeEditorLoading, setCodeEditorLoading] = useState(false);
  // const refSaveLoading = useRef(saveLoading);

  const [veevaModule, setVeevaModule] = useState([]);
  const [veevaContentData, setVeevaContentData] = useState([]);
  const [isEditModuleList, setIsEditModuleList] = useState(false);
  const [editCautionbtn, setEditCautionbtn] = useState(false);
  const [canvasHeight, setCanvasHeight] = useState();
  const [loadSuccess, setLoadSuccess] = useState(false);
  // const [veevaModuleSearchText, setVeevaModuleSearchText] = useState("");
  // const [veevaModuleCategory, setVeevaModuleCategory] = useState("");
  const [moduleList, setModuleList] = useState([]);

  const [userSelctedModuleList, setUserSelctedModuleList] = useState([]);
  const [linkedSearchExpression, setlinkedSearchExpression] = useState({});
  const [contentModules, setContentModules] = useState([]);
  const [searchParameters, setSearchParameters] = useState([]);
  const [swapped, setSwapped] = useState(false);
  const [isEdetailCreation, setIsEdetailCreation] = useState([]);
  const [slideCountDisplay, setSlideCountDisplay] = useState({});
  const [openExportModal, setOpenExportModal] = useState(false);
  const [openMLRPDF, setOpenMLRPDF] = useState(false);
  const [exportFormats, setExportFormats] = useState("");
  const [openPopover, setOpenPopover] = useState(false);
  const [switchToggleData, setSwitchToggleData] = useState("classic");
  const switchToggleDataRef = useRef(switchToggleData);
  const [pdfURL, setpdfURL] = useState("");
  // const handleEditModulebtn = async () => {
  //   setIsEditModuleList(true);
  //   setSearhModuleModal(true);
  //   setEditCautionbtn(true);
  // };
  const veevaContentDataRef = useRef(veevaContentData);
  const [selectNextModal, setSelectNextModal] = useState(false);

  const [activeTabName, setActiveTabName] = useState("component");
  const [tempSlideDetails, setTempSlideDetails] = useState({
    name: "",
    key_message: "",
  });
  const [scaleCentPercent, setScaleCentPercent] = useState(100);
  const [translateBfrZoomInout, setTranslateBfrZoomInout] = useState(0);
  const [zommedHundredPercent, setZommedHundredPercent] = useState(false);
  const [localScripts, setLocalScripts] = useState([]);
  const localScriptsRef = useRef(localScripts);

  const [customScripts, setcustomScripts] = useState([]);
  const [isloading, setIsloading] = useState(false);

  // Veeva and Next Modules
  const [linkedMMModules, setLinkedMMModules] = useState([]);
  const [linkedModule, setLinkedModule] = useState("");
  const [showAssociateModal, setShowAssociateModal] = useState(false);
  const [codeEditor, setCodeEditor] = useState(false);
  const [openCardDetailsModal, setOpenCardDetailsModal] = useState(false);
  const [cardInformation, setCardInformation] = useState();
  const [openRunValidationChecksModal, setOpenRunValidationChecksModal] =
    useState(false);
  const [runValidationChecksReportData, setRunValidationChecksReportData] =
    useState();
  const [nameDrop, setNameDrop] = useState();
  const [expandDetailDrop, setExpandDetailDrop] = useState(false);
  const [popoverAxis, setPopOverAxis] = useState({ left: 956, top: 68 });

  // const [modularToggle, setModularToggle] = useState(false);
  // const [modularContentType, setModularContentType] = useState("approved");
  const [referenceBetween, setReferenceBetween] = useState(false);
  const [modCurPopup, setModCurPopup] = useState(false);
  const [addReferenceBlock, setAddReferenceBlock] = useState(false);
  const [uploadFont, setUploadFont] = useState(false);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [expandLeft, setExpandLeft] = useState(261);
  const [expandRight, setExpandRight] = useState(261);
  const [undoCurrentStatus, setUndoCurrentStatus] = useState(undefined);
  const [redoCurrentStatus, setRedoCurrentStatus] = useState(true);
  const undoRedoInFlightRef = useRef(false);
  const [openSharedResource, setOpenSharedResource] = useState(false);
  // Responsiveness Code starts here
  const [selectedItem, setSelectedItem] = useState(null);
  const selectedItemRef = useRef(selectedItem);
  const [cssState, setCSSState] = useState({
    "dim_2048*1536": [],
    "dim_2388*1668": [],
    "dim_2752*2064": [],
    "dim_1024*768": [],
  });
  const [listOfID, setListOfID] = useState([]);
  const listOfIDRef = useRef(listOfID);
  const [storageObj, setStorageObj] = useState({});
  const storageObjRef = useRef(storageObj);
  const relatedClaimsDataRef = useRef([]);
  const cssRef = useRef(cssState);
  const [CodeEditorSave, setCodeEditorSave] = useState(false);
  const inputElementCode = useRef();
  const [closeTootltipTitle, setCloseTootltipTitle] = useState(true);
  const [selectedModule, setSelectedModule] = useState(undefined);
  const [activeTab, setActiveTab] = useState("first");

  const [loadingScripts, setLoadingScripts] = useState(false);

  const [flowCreatorLoading, setFlowCreatorLoading] = useState(false);
  const [cloneLoading, setCloneLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [editorHeightToast, setEditorHeightToast] = useState(false);
  const [switchEditorMode, setswitchEditorMode] = useState(false);
  const [ratioMode, setRatioMode] = useState(false);

  const [localVideoList, setLocalVideoList] = useState([]);
  const [localPosterList, setLocalPosterList] = useState([]);

  const [isMaxLengthToastOpen, setIsMaxLengthToastOpen] = useState(false);

  const isOneTimeContent = deckData?.tags?.includes("ONE_TIME_CONTENT");

  useEffect(()=> {
    if(deckData?.veevaMetadata && Array.isArray(deckData.veevaMetadata) && deckData.veevaMetadata.length){
      const veevaMeta = deckData.veevaMetadata[0]
      if(veevaMeta?.docStatus === "Approved for Use"){
        const type = deckData?.type == 1 ? "Template" : "e-Detail"
        showErrorToast(`This ${type} is approved for use and cannot be edited.`)
        setTimeout(()=> {
          if(type === "Template"){
            navigate("/template-manager")
          }else {
            navigate("/edetail-manager")
          }
        }, 2000)
      }
    }
  }, [deckData])

  useEffect(() => {
    const handleAutoSync = (data) => {
      try {
        const parsedData = JSON.parse(data);
        const deckId = parsedData.deckId || parsedData.deckid;
        if (!deckId) return;

        if (parsedData.type === "metadata_update" && parsedData.docStatus) {
          if (cardInformation) {
            setCardInformation((prevCardDetail) => {
              const assetIndex = (prevCardDetail.veevaMetadata ?? []).findIndex(
                (a) => a.assetType === 1,
              );
              let updatedItem = prevCardDetail;
              if (assetIndex !== -1) {
                const asset = prevCardDetail.veevaMetadata[assetIndex];
                if (asset.docStatus !== parsedData.docStatus) {
                  // clone item and metadata array only if changed
                  updatedItem = { ...updatedItem };
                  const newMetadata = [...(prevCardDetail.veevaMetadata ?? [])];
                  newMetadata[assetIndex] = {
                    ...asset,
                    docStatus: parsedData.docStatus,
                  };
                  updatedItem.veevaMetadata = newMetadata;
                }
              }
              return updatedItem;
            });
          }
        }
      } catch (error) {
        console.error("Error in handling autoSync:", error);
      }
    };

    emitter.on("autoSync", (data) => {
      handleAutoSync(data);
    });
  }, [cardInformation]);

  useEffect(() => {
    setLocalVideoList(deckData?.deck_shared_assets?.videos?.slice(0, 1) || []);
    setLocalPosterList(
      deckData?.deck_shared_assets?.posters?.slice(0, 1) || [],
    );
  }, [deckData]);

  useEffect(() => {
    loadingScripts || cloneLoading
      ? setSaveLoading(true)
      : setSaveLoading(false);
  }, [loadingScripts, cloneLoading]);

  useEffect(() => {
    if (videoSelected) {
      setState(true);
    }
  }, [videoSelected, toggle]);

  // const [rendertest ]
  useEffect(() => {
    listOfIDRef.current = listOfID;
    // <--- toggle off when user change the dimension
  }, [listOfID]);
  useEffect(() => {
    cssRef.current = cssState;
  }, [cssState]);

  useEffect(() => {
    storageObjRef.current = storageObj;

    // Restore CSS data from loaded slide back to cssRef
    if (storageObj && selectedItem && storageObj !== null) {
      const loadedCssObj = storageObj[selectedItem]?.cssObj;
      if (
        loadedCssObj &&
        Array.isArray(loadedCssObj) &&
        loadedCssObj.length > 0
      ) {
        // console.log("Restoring CSS data for dimension:", selectedItem, loadedCssObj);

        // Update cssState and cssRef with loaded CSS data
        setCSSState((prevState) => ({
          ...prevState,
          [selectedItem]: loadedCssObj,
        }));
      }
    }
  }, [storageObj, selectedItem]);
  const [dimensionVariable, setDimensionVariable] = useState(false);
  useEffect(() => {
    selectedItemRef.current = selectedItem;
    editor?.AssetManager?.close();
    (function myFunction(count) {
      // console.log("Function executed. Count:", count);
      if (dimensionVariable) {
        setSaveLoading(false);
        callEditor([]);
      } else if (count > 0) {
        myFunction(count - 1); // recursive call
      }
    })(3);

    /* (function myFunction(count) {
     
      if(dimensionVariable){
        debugger
        setSaveLoading(false);
        callEditor([]);
      }else{
        myFunction(count-1)        
      }
    })(3); */

    //editor?.store();
    setState(false);
    setListOfID([]);
  }, [selectedItem]);

  useEffect(() => {
    fetchBrands();
    fetchMarket();
    fetchCampaigns();
    if (!appData.deckId) {
      // only when page is refreshed and when new Deck is created **Not when Edited

      getAppData();
    }
  }, []);
  // MediaTabFunction(setState);

  useEffect(() => {
    if (!editor?.UndoManager) return;
    const um = editor.UndoManager;
    setRedoCurrentStatus(um.hasUndo());
    setUndoCurrentStatus(um.hasRedo());
  }, [editor]);

  useEffect(() => {
    if (editorHeightToast) {
      showSuccessToast(
        "Ensure all content stays within the designated wrapper. Avoid exceeding the editor's height to maintain design consistency.",
      );
    }
  }, [editorHeightToast]);

  // Base reference dimension for consistent visual size across all functions
  const baseDimension = { width: 1024, height: 768 };

  const dimen = {
    "dim_2752*2064": { width: 2752, height: 2064, padding: 90 },
    "dim_2388*1668": { width: 2388, height: 1668, padding: 60 },
    "dim_2048*1536": { width: 2048, height: 1536, padding: 50 },
    "dim_1024*768": { width: 1024, height: 768, padding: 30 },
  };

  const calculateNormalizedZoom = (
    selectedDimension,
    containerRect,
    scalePercent,
    expandLeftValue = expandLeft,
  ) => {
    if (!selectedDimension || !containerRect) {
      return 100;
    }

    const dimension = dimen[selectedDimension];
    if (!dimension) {
      return 100;
    }

    const clampedScalePercent = Math.max(
      20,
      Math.min(300, scalePercent || 100),
    );

    const scaleRatio = Math.min(
      baseDimension.width / dimension.width,
      baseDimension.height / dimension.height,
    );

    let availableWidth = containerRect.width;
    let widthPadding = 250;

    if (expandLeftValue === 450) {
      widthPadding = 150;
    } else {
      widthPadding = 250; // Normal padding
    }

    const containerRatio = Math.min(
      availableWidth / (baseDimension.width + widthPadding),
      containerRect.height / (baseDimension.height + 30),
    );

    const expansionMultiplier = expandLeftValue === 450 ? 1 : 1;
    const normalizedZoom =
      containerRatio *
      scaleRatio *
      100 *
      (clampedScalePercent / 100) *
      expansionMultiplier;

    const finalZoom = Math.max(10, Math.min(500, normalizedZoom));
    return finalZoom;
  };

  const refreshUndoRedoButtonState = () => {
    if (!editor?.UndoManager) return;
    const um = editor.UndoManager;
    setRedoCurrentStatus(um.hasUndo());
    setUndoCurrentStatus(um.hasRedo());
  };

  /** Wait two frames so the canvas iframe matches the model after undo/redo, then refresh + LHS sync once. */
  const scheduleAfterUndoRedoPaint = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          if (typeof editor.refresh === "function") {
            editor.refresh();
          }
          if (typeof editor.syncAllDimensionsFromRestore === "function") {
            editor.syncAllDimensionsFromRestore();
          }
          refreshUndoRedoButtonState();
          syncSelectedModuleUsedFromCanvas(editor, appData);
        } finally {
          undoRedoInFlightRef.current = false;
        }
      });
    });
  };

  const undoManager = () => {
    if (!editor?.UndoManager || undoRedoInFlightRef.current) return;
    const um = editor.UndoManager;
    if (!um.hasUndo()) {
      refreshUndoRedoButtonState();
      return;
    }
    undoRedoInFlightRef.current = true;
    um.undo();
    scheduleAfterUndoRedoPaint();
  };

  const redoManager = () => {
    if (!editor?.UndoManager || undoRedoInFlightRef.current) return;
    const um = editor.UndoManager;
    if (!um.hasRedo()) {
      refreshUndoRedoButtonState();
      return;
    }
    undoRedoInFlightRef.current = true;
    um.redo();
    scheduleAfterUndoRedoPaint();
  };

  const deckDetail = () => {
    getDeckTraceabilityMatrix(
      appData?.deckId?._id,
      // pageId,
      (response, err, errorCode) => {
        if (err) {
          console.log(err);
        } else {
          // console.log(response.data);
          setNameDrop(response.data);
          setEditorHeightToast(true);
        }
      },
    );
  };
  // const editorZoomIn = () => {
  //   setZommedHundredPercent(false);

  //   const canvas = editor?.Canvas;
  //   const zoom = canvas?.getZoom();
  //   if (scaleCentPercent === 90) {
  //     setZommedHundredPercent(true);
  //   }
  //   if (scaleCentPercent < 200) {
  //     canvas?.setZoom(
  //       (inputElement?.current?.getBoundingClientRect().height / (768 + 50)) *
  //         (scaleCentPercent + 10)
  //     );
  //     setScaleCentPercent((prevScale) => prevScale + 10);
  //   }
  // };

  window.addEventListener("resize", () => {
    if (editor) {
      const newZoomNumber = 100 - scaleCentPercent;
      if (scaleCentPercent < 100) {
        let editorHeight =
          inputElement?.current.getBoundingClientRect().height / (768 + 50) < 1
            ? editor.Canvas?.setZoom(
                (inputElement?.current.getBoundingClientRect().height /
                  (768 + 50)) *
                  100,
              )
            : editor?.Canvas?.setZoom(100);
        setScaleCentPercent(100);
        setZommedHundredPercent(true);
        // editor?.Canvas?.setZoom(
        //   (inputElement?.current?.getBoundingClientRect().height / (768 + 50)) *
        //     scaleCentPercent -
        //     newZoomNumber
        // );
      } else {
        editor?.Canvas?.setZoom(
          (inputElement?.current?.getBoundingClientRect().height / (768 + 50)) *
            scaleCentPercent,
        );
      }
    }
  });

  const handleClickOutside = (event) => {
    if (
      event.target.className === "adding-slide-subSlide" ||
      event.target.className === "ignoreClick"
    )
      return;
    setOpenPopover(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  // const resetZoom = () => {
  //   if (editor && scaleCentPercent !== 100) {
  //     // editor?.Canvas?.setZoom(
  //     //   editor?.Canvas?.getZoom() + (100 - scaleCentPercent)
  //     // );

  //     let editorHeight =
  //       inputElement?.current.getBoundingClientRect().height / (768 + 50) < 1
  //         ? editor.Canvas?.setZoom(
  //             (inputElement?.current.getBoundingClientRect().height /
  //               (768 + 50)) *
  //               100
  //           )
  //         : editor?.Canvas?.setZoom(100);
  //     setScaleCentPercent(100);
  //     setZommedHundredPercent(true);
  //   }
  // };
  // const resetZoom = () => {
  //   setZommedHundredPercent(true);
  //   if (editor) {
  //     editor?.Canvas?.setZoom(
  //       editor?.Canvas?.getZoom() + (100 - scaleCentPercent)
  //     );
  //     setScaleCentPercent(100);
  //     callEditor([]);
  //   }
  // };
  useEffect(() => {
    // console.log("Slide navigation detected, current slide changed:", currentSlide?.master?.slideid?._id);
    setScaleCentPercent(100);
    // setStorageObj(null);

    // Only reset CSS state if we're actually navigating to a different slide
    // This prevents CSS data loss during initial load
    if (currentSlide?.master?.slideid?._id) {
      setCSSState({
        "dim_2048*1536": [],
        "dim_2388*1668": [],
        "dim_2752*2064": [],
        "dim_1024*768": [],
      });
    }
    //setCSSState({ ratio_4_3: [], ratio_16_9: [], ratio_59_41: [] });
    if (editor?.AssetManager) {
      setState(false);
      editor?.AssetManager?.close();
    }
  }, [currentSlide]);

  const hideCurentPanel = () => {
    const divsList = document.querySelectorAll(
      "#genricInfoBlock, #leftPanelComponentsBlock, #veevLinkBlock",
    );
    divsList.forEach(function (element) {
      element.classList.remove("d-block");
      element.classList.add("d-none");
    });
  };
  const showCurrentPanel = (id, origin) => {
    const element = document.getElementById(id);
    if (
      element?.classList?.contains("d-block") &&
      origin !== "getGrapesjsEditor"
    ) {
      const panel1 = document.getElementById("componentSBlock");
      panel1.classList.add("d-none");
      setActiveTabName("");
      hideCurentPanel();
      return;
    }
    hideCurentPanel();
    if (id === "leftPanelComponentsBlock") {
      setActiveTabName("component");
    } else if (id === "genricInfoBlock") {
      setActiveTabName("genericInfo");
    } else {
      setActiveTabName("veeva");
    }
    const panel = document.getElementById("componentSBlock");
    panel.classList.remove("d-none");
    element.classList.remove("d-none");
    element.classList.add("d-block");
  };

  const isToastOpenRef = useRef(false);
  const showSessionOutErrorToast = (msg) => {
    if (isToastOpenRef.current) return;
    isToastOpenRef.current = true;
    showErrorToast(msg);
    setTimeout(() => {
      isToastOpenRef.current = false;
    }, 3000);
  };

  const fetchBrands = () => {
    getBrandDetails((response, err, errorCode) => {
      if (err) {
        if (errorCode === 401) {
          showSessionOutErrorToast(
            "Your session has expired. Please sign in again.",
          );
          keycloak.logout();
        }
      } else {
        //parse and save
        const data = response.data;
        if (data) {
          setBrands(data);
        }
      }
    });
  };

  const fetchMarket = () => {
    getMarketDetails((response, err, errorCode) => {
      if (err) {
        if (errorCode === 401) {
          showSessionOutErrorToast(
            "Your session has expired. Please sign in again.",
          );
          keycloak.logout();
        }
      } else {
        //parse and save
        const data = response.data;
        if (data) {
          setMarket(data);
        }
      }
    });
  };

  const fetchCampaigns = () => {
    getCampaignDetails((response, err, errorCode) => {
      if (err) {
        if (errorCode === 401) {
          showSessionOutErrorToast(
            "Your session has expired. Please sign in again.",
          );
          keycloak.logout();
        }
      } else {
        //parse and save
        const data = response.data;
        if (data) {
          setCampaign(data);
        }
      }
    });
  };

  useEffect(() => {
    showAllSlidesRef.current = showAllSlides;
    if (!showAllSlides) {
      setLoading(true);
    }
  }, [showAllSlides]);
  useEffect(() => {
    switchToggleDataRef.current = switchToggleData;
  }, [switchToggleData]);

  // useEffect(() => {
  //   setSaveLoading(refSaveLoading.current);
  // }, [refSaveLoading.current]);

  useEffect(() => {
    if (slideID?.length < 1) return;
    currentSlideRef.current = currentSlide;
    slideListRef.current = slideID;
    setVideoSelected(false);
    setswitchEditorMode(false);
    // setContentModules([]);
    //  console.log("currentSlideRef", currentSlideRef);
  }, [currentSlide, slideID]);

  useEffect(() => {
    localScriptsRef.current = localScripts;
  }, [localScripts]);

  useEffect(() => {
    veevaContentDataRef.current = veevaContentData;
  }, [veevaContentData]);
  let slides = [];

  const getVeevaLinkedmodules = (newslideId) => {
    let IDRef =
      (JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id) || newslideId;
    if (!IDRef) {
      return;
    }

    // getVeevaLinkedModulesListByid(
    //   appData?.deckId?._id,
    //   IDRef,
    //   (response, err, errorCode) => {
    //     if (err) {
    //       setIsloading(false);
    //       let veevadata = [];
    //       setLinkedModule("");
    //       setContentModules([]);
    //       setLinkedMMModules([]);
    //       setlinkedSearchExpression([]);
    //       setSearchedText("");
    //       setUserSelctedModuleList(veevadata);
    //       setVeevaContentData([]);
    //     } else {
    //       let data = response.data.content_modules;
    //       setIsloading(false);
    //       let veevadata = [];
    //       data.forEach((item) => veevadata.push(item.moduleid));

    //       setContentModules(veevadata);
    //       // setSearchedText(response?.data?.search_expression?.name);
    //       // setSelectedCategory(
    //       //   response?.data?.search_expression?.claim_category
    //       // );

    //       setLinkedMMModules(data);
    //       setlinkedSearchExpression(response.data.search_expression);
    //       setSearchedText(response?.data?.search_expression?.name);
    //       setSelectedCategory(
    //         response?.data?.search_expression?.claim_category
    //       );
    //       setUserSelctedModuleList(veevadata);
    //       //
    //       //   setVeevaModule(veevadata);
    //       setLinkedModule(response.data.module_type);
    //       if (response.data.module_type !== "NEXT") {
    //         getVeevaModuleCardinfo(veevadata);
    //         // setVeevaContentData(veevadata);
    //       }
    //     }
    //   }
    // );
  };
  useEffect(() => {
    if (appData?.deckId?._id === null || appData?.deckId?._id === undefined)
      return;

    // if(appData?.deckId?.veevaMetadata && !ValidateStatusCriteria(appData?.deckId)) {
    //   navigate("/"); //  '${appData?.deckId?.name}'
    //   showErrorToast(appData?.deckId.type == 1 ? "Template is not editable." : `e-Detail is not editable.`);
    //   return;
    // }

    const fetchData = async () => {
      let ids = [];
      let Localeditor = null;
      // if (!appData.deckId) {
      //   // only when page is refreshed and when new Deck is created **Not when Edited
      //   getAppData();
      // }
      window.localStorage.removeItem("gjsProject");

      await getSlidesListForDeck(appData?.deckId?._id);

      ids = slides;

      if (ids.length === 0) {
        return;
      }
      if (appData?.deckId?._id !== undefined) {
        getVeevaLinkedmodules(ids[0]?.slideid?._id);
      }
      // await getFirstSlideSavedContents(ids, Localeditor || editor);

      setSlideID(ids);
      setSlideNameCount(slides[0].length);
      if (
        ids.filter((ele) => {
          if (ele.slideid._id === pageId) return true;
        }).length > 0
      ) {
        ids.forEach((id, index) => {
          if (id.slideid._id === pageId) {
            setCurrentSlide({ master: slides[index], child: {} });
            navigate(`/editor/${slides[index].slideid?._id}`, {
              replace: true,
            });
            setLoading(false);
            setSlideCountDisplay(index + 1);
            setSlideCount(index + 1);
          } else if (id.children.length > 0) {
            id.children.forEach((childObjId) => {
              if (childObjId.slideid._id === pageId) {
                setCurrentSlide({ master: slides[index], child: {} });

                navigate(`/editor/${slides[index].slideid?._id}`, {
                  replace: true,
                });

                setSlideCountDisplay(index + 1);
                setSlideCount(index + 1);
                setLoading(false);
              }
            });
          }

          return;
        });
      } else {
        setCurrentSlide({ master: slides[0], child: {} });
        //navigate to first slide

        navigate(`/editor/${slides[0].slideid?._id}`, { replace: true });
        setLoading(false);
      }
    };
    fetchData();
    deckDetail();
  }, [appData?.deckId?._id, showAllSlides]);

  const customDrag = (e) => {
    const root = e.currentTarget || e.target;
    const ghost = (e.nativeEvent && e.nativeEvent.srcElement) || root;
    try {
      e.dataTransfer.setDragImage(ghost, 0, 0);
    } catch (_) {}
    e.dataTransfer.effectAllowed = "copyMove";
    const plain = root?.innerText || "";
    e.dataTransfer.setData("text/plain", plain);
    e.dataTransfer.setData("text", plain);
    if (root?.tagName === "IMG" && root.getAttribute("src")) {
      const src = root.getAttribute("src");
      const payload = {
        componentUrl: src,
        dataContentId: src,
      };
      e.dataTransfer.setData("application/json", JSON.stringify(payload));
    }
  };

  useEffect(() => {
    // if (!appData.deckId) {
    //   // only when page is refreshed and when new Deck is created **Not when Edited
    //   getAppData();
    // }
    if (
      !(currentSlide?.master?.slideid?._id || currentSlide?.child?.slideid?._id)
    )
      return;

    const activeSlideIdForScripts =
      JSON.stringify(currentSlide?.child) === "{}"
        ? currentSlide?.master?.slideid?._id
        : currentSlide?.child?.slideid?._id;
    const slideChangedForScriptsLoad =
      slideScriptsLoadKeyRef.current !== activeSlideIdForScripts;
    slideScriptsLoadKeyRef.current = activeSlideIdForScripts;

    setVideoSelected(false);
    setState(false);
    setLoadingScripts(true);
    async function loadScripts() {
      let resp = await instance
        .get(
          `/slides/${
            JSON.stringify(currentSlide?.child) === "{}"
              ? currentSlide?.master?.slideid?._id
              : currentSlide?.child?.slideid?._id
          }`,
        )
        .then(({ data }) => {
          let localLink = data.local_libraries?.map((obj) => obj.link) || [];
          let sharedLink =
            appData.deckId?.shared_libraries?.map((obj) => obj.link) || [];
          let getLocalScripts =
            data.custom_script !== null
              ? [data?.custom_script?.url, ...localLink]
              : localLink;
          if (slideChangedForScriptsLoad && appData.deckId?.default_aspect_ratio) {
            setSelectedItem(appData.deckId.default_aspect_ratio);
          }
          callEditor([]);
          setLoading(false);
          setSwitchToggleData(data?.smart_template || "classic");
        })
        .catch((error) => {
          console.log(error);
          callEditor([]);
        });

      //console.log(editor);
      setLinkedModule("");

      setContentModules([]);
      getSlidesListForDeck();
      getVeevaLinkedmodules();
    }
    loadScripts();
    setLoadingScripts(false);
  }, [
    currentSlide?.master?.slideid?._id,
    currentSlide?.child?.slideid?._id,
    customScripts,
    codeEditor,
  ]);

  useEffect(() => {
    callEditor([]);

    return () => {
      setEditor(null);
    };
  }, [showAllSlides, codeEditor]);

  const callEditor = (localLink) => {
    if (showAllSlides) return;
    setLoadSuccess(true);
    if (JSON.stringify(currentSlide) === "{}") return;

    let Localeditor = null;
    if (!editor?.em?.destroyed) {
      editor?.destroy();
    }
    setEditor(null);
    // console.log(appData);
    setswitchEditorMode(false);
    Localeditor = getGrapeJsEditor({
      setDimensionVariable,
      setState,
      setVideoSelected,
      currentSlideRef,
      setShowPreView,
      setpreviewURl,
      slideListRef,
      setCurrentSlide,
      switchToggleDataRef,
      slideID,
      setSlideID,
      saveLoading,
      setSaveLoading,
      loadSuccess,
      setLoadSuccess,
      setExportLoading,
      showCurrentPanel,
      activeTabName,
      showSlidesPanel,
      showAllSlides,
      veevaContentDataRef,
      showAllSlidesRef,
      setOpenExportModal,
      openExportModal,
      localLink,
      setLocalScripts,
      setUndoCurrentStatus,
      setRedoCurrentStatus,
      setReferenceBetween,
      addReferenceBlock,
      setAddReferenceBlock,
      setUploadFont,
      appData,
      setOpenDocumentModal,
      setExpandLeft,
      setExpandRight,
      selectedItem,
      setCSSState,
      cssRef,
      storageObjRef,
      setStorageObj,
      listOfIDRef,
      setListOfID,
      codeEditor,
      CodeEditorSave,
      setLoading,
      relatedClaimsDataRef,
    });
    // setLoading(false)
    if (!codeEditor && selectedItem) {
      const extraPadding = {
        "dim_2752*2064": { addPadding: 117, removePadding: 167 }, //97, 147 old
        "dim_2388*1668": { addPadding: 50, removePadding: 98 }, //40, 88 old
        "dim_2048*1536": { addPadding: 117, removePadding: 164 }, //107, 154 old
        "dim_1024*768": { addPadding: 124, removePadding: 171 },
      };
      const dimen = {
        "dim_2752*2064": { width: 2752, height: 2064 },
        "dim_2388*1668": { width: 2388, height: 1668 },
        "dim_2048*1536": { width: 2048, height: 1536 },
        "dim_1024*768": { width: 1024, height: 768 },
      };

      let canvasElem = document.getElementsByClassName(
        "gjs-cv-canvas__frames",
      )[0];
      let editor = document.getElementById("gjsEditor");
      canvasElem.style.width = dimen[selectedItem].width + "px";
      canvasElem.style.height = dimen[selectedItem].height + "px";
      const apply =
        inputElement?.current?.getBoundingClientRect()?.width /
          (dimen[selectedItem].width + 300) <
        1
          ? Localeditor.Canvas.setZoom(
              ((inputElement?.current?.getBoundingClientRect()?.width -
                (expandLeft === 450
                  ? extraPadding[selectedItem].removePadding
                  : extraPadding[selectedItem].addPadding)) /
                dimen[selectedItem].width) *
                100,
            )
          : "";
      /* const scaleX = canvasElem.clientWidth / dimen[selectedItem].width;  // original width
          const scaleY = canvasElem.clientHeight / dimen[selectedItem].height; // original height
          const scale = Math.min(scaleX, scaleY);
          editor.style.transform = `scale(${scale})`; */
      editor.style.transformOrigin = "top left";
    } else {
      if (codeEditor) {
        let editorHeight =
          inputElementCode?.current.getBoundingClientRect().height /
            (768 + 100) <
          1
            ? Localeditor.Canvas.setZoom(
                (inputElementCode?.current.getBoundingClientRect().height /
                  (768 + 73)) *
                  100,
              )
            : "";
      } else {
        let editorHeight =
          inputElement?.current.getBoundingClientRect().height / (768 + 30) < 1
            ? Localeditor?.Canvas.setZoom(
                (inputElement?.current.getBoundingClientRect().height /
                  (768 + 30)) *
                  100,
              )
            : "";
      }
      let canvasElem = document.getElementsByClassName(
        "gjs-cv-canvas__frames",
      )[0];
      canvasElem.style.width = "1024px";
      canvasElem.style.height = "768px";
    }
    setEditor(Localeditor);
    // console.log(Localeditor);
    attachClick(Localeditor);
    let canvasElem = document.getElementsByClassName(
      "gjs-cv-canvas__frames",
    )[0];
    if (
      document
        .querySelector(".editor-wrapper-tab-content")
        ?.getBoundingClientRect().width < 390
    ) {
      const ab = document.getElementsByClassName("gjs-block-categories")[0];
      ab.classList.add("collapse-column");
    }

    if (scaleCentPercent === 100) setTranslateBfrZoomInout(canvasWidth);
    // if (zommedHundredPercent) canvasWidth = translateBfrZoomInout ||0;
    // setCounter((prevCounter) => prevCounter++);
    // }
    let IDRef =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
    if (appData?.deckId?._id !== undefined) {
      getVeevaLinkedmodules(IDRef);
    }
    setZommedHundredPercent(false);
    attachClick(Localeditor);

    !codeEditor && setTimeout(() => setCodeEditorLoading(false), 1000);
  };

  window.onpopstate = () => {
    navigate("/", { replace: true });
  };

  const getSlidesListForDeck = async (ID) => {
    let cardDataID = appData?.deckId?._id;

    if (cardDataID)
      await geteDetailByID(cardDataID, async (response, err, errorCode) => {
        if (err) {
        } else {
          // console.log("settingDEckIngetSlidesListForDeck", response);
          // appData.setDeckId(response.data);

          slides = response?.data?.slides;
          appData.setDeckId(response?.data);
          setDeckData(response.data);
          setIsEdetailCreation(response?.data?.type);
          setSelectedItem((prev) =>
            prev == null ? response.data.default_aspect_ratio : prev,
          );
          const slidesList = [];
          response?.data?.slides.forEach((element) => {
            slidesList.push({ id: element.slideid, name: element.slideid });
          });
          window.localStorage.setItem("slidelist", JSON.stringify(slidesList));
        }
      });
  };

  // const setEditorPage = (obj, grapesjsEditor) => {
  //   if (document.getElementById("blocks")) {
  //     document.getElementById("blocks").innerHTML = "";
  //     document.getElementById("stylesMangerBlock").innerHTML = "";
  //     document.getElementById("editor-actions-btns").innerHTML = "";
  //   }
  //   grapesjsEditor.render();
  //   grapesjsEditor.editor.setStyle(
  //     `
  //     .modal{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6)}
  //     .modal-content{margin:0;height:100%;width:100%;padding:0;}.close{float:right;}iframe.modal-iframe{height:100%;width:100%;border:0;margin-top:20px;}[data-slide-id]{cursor:pointer}
  //      `
  //   );

  //   navigate(`/editor/${obj._id}`);

  //   setTimeout(() => {
  //     const otherBlock = document.querySelector(
  //       ".gjs-block-categories .gjs-blocks-c"
  //     );
  //     otherBlock && otherBlock.classList.add("d-none");
  //   }, 0);
  // };

  // const assignSlideNameNKeyMessageToId = (ids, obj) => {
  //   ids[0].slideid.name = obj?.content
  //     ? obj?.content?.slideName || ids[0]?.slideid?.name
  //     : ids[0]?.slideid?.name;

  //   ids[0].slideid.key_message = obj?.content
  //     ? obj?.content?.keyMessage ||
  //       ids[0]?.slideid?.key_message ||
  //       "Enter Key Message"
  //     : ids[0]?.slideid?.key_message || "Enter Key Message";
  // };
  const getDeckData = async (cardDataID) => {
    if (cardDataID) {
      await geteDetailByID(cardDataID, async (response, err, errorCode) => {
        if (err) {
        } else {
          let data = await response.data;
          //setNameDrop(response.data);
          if (data.locked) {
            const userInfo = JSON.parse(localStorage.getItem("Info-user"));
            if (userInfo.email !== data.created.username) {
              navigate(
                data?.type == template
                  ? "/template-manager"
                  : "/edetail-manager",
              );
              showErrorToast("Template is locked.");
            }
          }
          if (data.expired) {
            navigate(
              data?.type == template ? "/template-manager" : "/edetail-manager",
            );
            showErrorToast(
              data.type == 1 ? "Template is Expired." : "e-Detail is Expired",
            );
            return;
          }
          appData.setDeckId(data);
          //setdata to fetch it later in trait options for popup
          const cardData = {
            edetailId: response.data._id,
            slides: [],
          };
          cardData.slides.push({
            slideid: response.data.slides[0].slideid._id,
          });
          const slidesList = [];
          data?.slides?.forEach((element) => {
            slidesList.push({ id: element.slideid, name: element.slideid });
          });
          window.localStorage.setItem("slidelist", JSON.stringify(slidesList));
          // end
        }
      });
    }
  };

  const attachClick = (Localeditor) => {
    document.getElementById("blocks").addEventListener(`click`, (e) => {
      if (e.target.classList.contains("custom-images")) return;
      if (Localeditor.AssetManager) {
        setState(false);
        Localeditor?.AssetManager?.close();
      }
    });
  };
  const getAppData = async (id) => {
    // let cardData = appData?.deckId?._id || null;

    // if (pageId) {
    //   if (pageId) {
    // cardData = getDeckData(pageId);
    // if (
    //   slides.filter((ele) => {
    //     if (ele.slideid._id === pageId) return true;
    //   }).length > 0
    // ) {
    //   slides.forEach((id, index) => {
    //     if (id.slideid._id === pageId) {
    //       setCurrentSlide({ master: slides[index], child: {} });
    //       navigate(`/editor/${slides[index].slideid?._id}`, {
    //         replace: true,
    //       });
    //       setSlideCountDisplay(index + 1);
    //     } else if (id.children.length > 0) {
    //       id.children.forEach((childObjId) => {
    //         if (childObjId.slideid._id === pageId) {
    //           setCurrentSlide({ master: slides[index], child: {} });
    //           navigate(`/editor/${slides[index].slideid?._id}`, {
    //             replace: true,
    //           });
    //           setSlideCountDisplay(index + 1);
    //         }
    //       });
    //     }

    //     return;
    //   });
    // } else {
    //   setCurrentSlide({ master: slides[0], child: {} });
    //   //navigate to first slide

    //   navigate(`/editor/${slides[0].slideid?._id}`, { replace: true });
    // }
    await getSlideDetailsById(pageId, async (response, err, errorCode) => {
      if (err) {
        navigate("/", { replace: true });
      } else {
        setSwitchToggleData(response?.data?.smart_template);
        await getDeckData(response?.data?.member_of[0]);
      }
    });
  };

  // // on click label
  const onEnterSlideKeyName = (type) => {
    if (type === "slide") {
      setShowEnterSlideNameInput(true);
      setShowEnterKeyMessageInput(false);
      document?.getElementById("message-input")?.focus();
    } else {
      setShowEnterKeyMessageInput(true);
      setShowEnterSlideNameInput(false);
    }
  };
  const updateSlideDetails = (name, value) => {
    let ID =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
    let payLoad = { [name]: value };
    updatSlideData(ID, payLoad, (response, err, errorCode) => {
      if (err) {
        // refSaveLoading.current = true;
        if (JSON.stringify(currentSlide.child) === "{}")
          setTempSlideDetails({
            ...tempSlideDetails,
            [name]: currentSlide.master.slideid[name],
          });
        else {
          setTempSlideDetails({
            ...tempSlideDetails,
            [name]: currentSlide.child.slideid[name],
          });
        }
        if (errorCode === 400) {
          if (
            err.response.data?.err?.message?.includes(
              "names cannot be duplicated",
            )
          ) {
            showErrorToast(
              `Slide names cannot be duplicated within ${
                appData?.deckId?.type == 1 ? "a template" : "an e-detail"
              }.`,
            );
          } else {
            showErrorToast(err.response.data.message);
          }
        }
      } else {
        let tempCurrentSlide = JSON.parse(JSON.stringify(currentSlide));
        if (JSON.stringify(tempCurrentSlide.child) === "{}")
          tempCurrentSlide.master.slideid[name] = value;
        else {
          tempCurrentSlide.child.slideid[name] = value;
          tempCurrentSlide.master.children[
            tempCurrentSlide.child.index - 1
          ].slideid[name] = value;
        }

        setCurrentSlide(tempCurrentSlide);
        slideID[currentSlide.master.index - 1] = tempCurrentSlide?.master;
        getSlidesListForDeck();
      }
    });
  };

  const showMaxLengthToast = (msg) => {
    if (isMaxLengthToastOpen) return; // block repeated toasts
    setIsMaxLengthToastOpen(true);
    showErrorToast(msg);
    // Unlock toast after autoClose time (e.g., 3000ms)
    setTimeout(() => {
      setIsMaxLengthToastOpen(false);
    }, 3000);
  };

  // on Enter input
  const slideMessageSubmit = (e, submitType, defaultVal) => {
    if (e.target.value.length > 50) {
      showMaxLengthToast(`${defaultVal} exceeded the maximum length`);
      return;
    }

    let { name, value } = e.target;

    if (name === "name") {
      const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
      if (specialChars.test(value) || value.includes(" ")) return;
    } else if (name === "key_message") {
      const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
      if (
        specialChars.test(value) ||
        (value.length > 0 && value[0].includes(" "))
      )
        return;
    }
    if (submitType === "blur" || e.key === "Enter") {
      if (value === "" || value.trim().length === 0) {
        if (JSON.stringify(currentSlide.child) === "{}")
          value = currentSlide.master.slideid[name];
        else {
          value = currentSlide.child.slideid[name];
        }
      }
      //   value = `Enter${defaultVal}`;
      // savePage(editor, currentSlide);
      updateSlideDetails(name, value);
      setShowEnterSlideNameInput(false);
      setShowEnterKeyMessageInput(false);
    }
    // tempSlideDetails[name] = value;
    setTempSlideDetails({ ...tempSlideDetails, [name]: value });
    // let tempCurrentSlide = JSON.parse(JSON.stringify(currentSlide));
    // if (JSON.stringify(tempCurrentSlide.child) === "{}")
    //   tempCurrentSlide.master.slideid[name] = value;
    // else {
    //   tempCurrentSlide.child.slideid[name] = value;
    //   tempCurrentSlide.master.children[
    //     tempCurrentSlide.child.index - 1
    //   ].slideid[name] = value;
    // }
    // setCurrentSlide(tempCurrentSlide);
    // slideID[currentSlide.master.index - 1] = tempCurrentSlide.master;
  };

  const getFieldValue = (val) => {
    return tempSlideDetails[val];
  };

  // const handleSearchModalShow = (type) => {
  //   setSearhModuleModal(true);
  //   setEditCautionbtn(false);
  //   setVeevaModule([]);
  //   setSearchedText("");
  //   setSelectedCategory("");
  //   setModuleList([]);
  //   setUserSelctedModuleList([]);
  // };

  const showSlidesPanel = (status) => {
    setShowAllSlides(status);
  };

  // const getSearchData = (token) => {
  //   const data = {
  //     brandName: "",
  //     claimCategory: [],
  //     name: "cm",
  //     campaign: "",
  //   };
  //   imcSearchContentModules(token, data, (response, err, errorCode) => {
  //     if (err) {
  //       console.log(err);
  //     } else {
  //       console.log(response);
  //     }
  //   });
  // };

  const handleSearchModalHide = (type) => {
    setSearhModuleModal(false);
    setVeevaModule([]);
    setSearchedText("");
    setSelectedCategory("");
    setModuleList([]);
    setUserSelctedModuleList([]);
    setCloseTootltipTitle(true);
    if (appData?.deckId?._id !== undefined) {
      getVeevaLinkedmodules(pageId);
    }
  };

  const handleSelectNextModalShow = () => {
    setSelectNextModal(true);
  };

  const handleSelectNextModalHide = () => {
    setSelectNextModal(false);
  };
  const getVeevaModuleCardinfo = (idsArr) => {
    let ID =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
    if (linkedModule === "NEXT") {
      return;
    }
    if (!ID) {
      return;
    }
    setIsloading(true);
  };

  useEffect(() => {
    if (JSON.stringify(currentSlide) === "{}") return;
    if (JSON.stringify(currentSlide.child) === "{}") {
      setTempSlideDetails({
        name: currentSlide?.master?.slideid?.name,
        key_message:
          currentSlide?.master?.slideid?.key_message || "Enter Key Message",
      });
    } else
      setTempSlideDetails({
        name: currentSlide?.child?.slideid?.name,
        key_message:
          currentSlide?.child?.slideid?.key_message || "Enter Key Message",
      });
    setIsEditModuleList(false);
    setActiveTab("first");
  }, [currentSlide]);

  const slideHandler = (e) => {
    setOpenPopover((prev) => !prev);
    setPopOverAxis({
      top: e.target.getBoundingClientRect().top + e.target.height,
      left:
        e.target.getBoundingClientRect().left +
        e.target.width / 2 -
        (expandRight === 261 ? 0 : 176),
    });
  };
  const handleExportModal = (id) => {
    // setOpenExportModal(true);
  };
  const closeExportModal = () => {
    setOpenExportModal(false);
    setExportFormats("");
  };
  const handleExport = () => {
    if (exportFormats === "htmlveevaPackage") {
      let cardDataID = appData?.deckId?._id;

      setExportLoading(true);
      ExportDeckToMail(cardDataID, (response, err, errorCode) => {
        if (err) {
          showErrorToast("Export failed. Pl try again");

          setExportLoading(false);
        } else {
          showSuccessToast(response.data || "Link will be emailed");
          setExportLoading(false);
        }
      });

      setOpenExportModal(false);
      setExportFormats("");
    } else if (exportFormats === "mlrPdf") {
      setMlrPdfLoader(true);
      PDFPreview(appData.deckId._id, (response, err, errorCode) => {
        if (err) {
          console.log(err);
          setMlrPdfLoader(false);
          showErrorToast(" Export failed. Pl try again");
        } else {
          setMlrPdfLoader(false);
          setpdfURL(response.data);
          setOpenExportModal(false);
          showSuccessToast(response.data || "Link will be emailed");
        }
      });
    }
  };
  useEffect(() => {
    setSlideCountDisplay(slideCount);
  }, [slideCount]);

  if (editor) {
    var iframeBody = editor?.Canvas?.getBody();

    if (!iframeBody) {
      return;
    }
    iframeBody.onpaste = function (e) {
      if (
        e.clipboardData.files.length > 0 ||
        !e.target.hasAttribute("contenteditable")
      ) {
        e.preventDefault();
        return false;
      }
      e.stopPropagation();
      // var pastedText = undefined;
      const pastedText = e.clipboardData
        ? (e.originalEvent || e).clipboardData.getData("text/plain")
        : // For IE
        window.clipboardData
        ? window.clipboardData.getData("Text")
        : "";
      const selection = e.target.ownerDocument.getSelection();

      selection.deleteFromDocument();
      selection
        .getRangeAt(0)
        .insertNode(document.createTextNode(pastedText.trim()));
      selection.collapseToEnd();

      return false; // Prevent the default handler from running.
    };
  }

  const cardInfoHandler = () => {
    //console.log("appdata", appData, deckData);
    getDeckTraceabilityMatrix(
      appData?.deckId?._id,
      (response, err, errorCode) => {
        if (err) {
          console.log(err);
        } else {
          //console.log(response.data);
          setCardInformation(response.data);
          setOpenCardDetailsModal(true);
        }
      },
    );
    //setCardDetails(cardData);
  };

  const closeCardDetailsModal = () => {
    setOpenCardDetailsModal(false);
  };

  const runValidationChecks = () => {
    setFlowCreatorLoading(true);
    getVeevaLinkedModulesListByid(
      appData?.deckId?._id,
      (response, err, errorCode) => {
        if (err) {
          console.log(err);
          setFlowCreatorLoading(false);
        } else {
          //console.log(response.data);
          const data = response.data.response;
          const moduleData = data?.selected_module_data || [];

          setRunValidationChecksReportData(moduleData);
          
          if (moduleData.length > 0 && moduleData.find((list)=>list.count < 1)) {
            setOpenRunValidationChecksModal(true);
            setFlowCreatorLoading(false);
          }
          setFlowCreatorLoading(false);
        }
      },
    );
  };

  /* const switchHandler = (e) => {
    // setIsloading(true);
    const ID =
      JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
    let payLoad = "";
    let compSelected = editor.getSelected() || {};
    if (e.target.checked) {
      setSwitchToggleData("modular");
      payLoad = { smart_template: "modular" };

      editor.getComponents().forEach((n) => {
        if (
          compSelected?.attributes?.name === "Row" &&
          compSelected?.components().length === 1
        ) {
          compSelected.set({ unstylable: [""] });
          const propMod = document.querySelector(
            ".gjs-sm-sector__modular_content"
          );
          propMod.classList.remove("d-none");
          propMod.classList.add("d-block");
        }
      });
    } else {
      if (editor?.getWrapper().find("[modularBlock]").length > 0) {
        setModCurPopup(true);
      } else {
        setSwitchToggleData("classic");
        payLoad = { smart_template: "classic" };
        if (
          compSelected?.attributes?.name === "Row" &&
          compSelected?.components().length === 1
        ) {
          compSelected.set({ unstylable: ["modular_content"] });
          const propMod = document.querySelector(
            ".gjs-sm-sector__modular_content"
          );
          propMod.classList.remove("d-block");
          propMod.classList.add("d-none");
        }
      }

      // return;
    }

    updatSlideData(ID, payLoad, (response, err, errorCode) => {
      //  console.log(response, "errrrr", err, e.target.checked);
      if (err) {
        //setIsloading(false);
      } else {
        //setIsloading(false);
      }
    });
  }; */

  const gotoReorder = async (origin) => {
    setFlowCreatorLoading(true);
    await editor.store();
    await geteDetailByID(
      appData?.deckId?._id,
      async (response, err, errorCode) => {
        if (err) {
          setFlowCreatorLoading(false);
        } else {
          let data = await response.data;

          setSlideID(data.slides);
          setTimeout(() => {
            showSlidesPanel(!showAllSlides);
          }, 1000);
        }
      },
      true, // skipStatus
    );
  };

  const expandName = () => {
    setExpandDetailDrop(!expandDetailDrop);
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  // const modularOnChange = () => {
  //   setModularToggle(!modularToggle);
  // };
  // const contentType = (event) => {
  //   console.log("---------", event.target.defaultValue);
  //   setModularContentType(event.target.defaultValue);
  // };

  const expandRightHandler = (type) => {
    const ab = document.getElementsByClassName("gjs-block-categories")[0];
    const hideProperties = document.getElementsByClassName(
      "right-left-section-properties",
    )[0];
    const hidePropertiesPannel =
      document.getElementsByClassName("propertiesBlock")[0];
    if (type === "left") {
      if (expandLeft === 261) {
        setExpandLeft(450);
        setExpandRight(25);
        hideProperties.classList.add("d-none");
        hideProperties.classList.remove("d-block");
        hidePropertiesPannel.classList.add("d-none");
        hidePropertiesPannel.classList.remove("d-block");
        ab.classList.add("expand-column");
        ab.classList.remove("collapse-column");
      } else if (expandLeft === 450) {
        setExpandLeft(261);
        setExpandRight(261);
        ab.classList.remove("expand-column");
        ab.classList.add("collapse-column");
        hideProperties.classList.add("d-block");
        hideProperties.classList.remove("d-none");
        hidePropertiesPannel.classList.add("d-block");
        hidePropertiesPannel.classList.remove("d-none");
      }
    } else if (type === "right") {
      if (expandLeft === 261) {
        setExpandLeft(450);
        setExpandRight(25);
        ab.classList.add("expand-column");
        ab.classList.remove("collapse-column");
        hideProperties.classList.add("d-none");
        hideProperties.classList.remove("d-block");
        hidePropertiesPannel.classList.add("d-none");
        hidePropertiesPannel.classList.remove("d-block");
      } else if (expandLeft === 450) {
        setExpandRight(261);
        setExpandLeft(261);
        ab.classList.add("collapse-column");
        ab.classList.remove("expand-column");
        hideProperties.classList.add("d-block");
        hideProperties.classList.remove("d-none");
        hidePropertiesPannel.classList.add("d-block");
        hidePropertiesPannel.classList.remove("d-none");
      }
    }
    editor.refresh();

    if (selectedItem && inputElement?.current && editor?.Canvas) {
      const containerRect = inputElement.current.getBoundingClientRect();

      const newExpandLeft =
        type === "left"
          ? expandLeft === 261
            ? 450
            : 261
          : expandLeft === 261
          ? 450
          : 261;

      const normalizedZoom = calculateNormalizedZoom(
        selectedItem,
        containerRect,
        scaleCentPercent,
        newExpandLeft,
      );

      let canvasElem = document.getElementsByClassName(
        "gjs-cv-canvas__frames",
      )[0];
      if (canvasElem) {
        canvasElem.style.width = dimen[selectedItem].width + "px";
        canvasElem.style.height = dimen[selectedItem].height + "px";
      }

      const wrapperDiv = editor?.DomComponents?.getComponents()?.at(0);
      if (wrapperDiv) {
        let wrap = wrapperDiv?.getStyle();
        wrapperDiv.setStyle({
          ...wrap,
          width: dimen[selectedItem].width + "px",
          height: dimen[selectedItem].height + "px",
        });
      }

      let cssObj = storageObjRef?.current[selectedItem]?.cssObj || [];
      cssObj.forEach((obj) => {
        if (obj.id !== "wrapper" && wrapperDiv) {
          let elem = wrapperDiv.find("#" + obj.id)[0];
          if (elem) {
            let elemStyle = elem?.getStyle() || {};
            const extras = filterCssObjForPerDimension(elemStyle, obj);
            elem?.setStyle({
              ...elemStyle,
              ...extras,
            });
          }
        }
      });

      setTimeout(() => {
        editor.Canvas.setZoom(normalizedZoom);

        const frameWrapper = document.querySelector(".gjs-cv-canvas__frames");
        const canvasWrapper = document.querySelector(".gjs-cv-canvas");

        if (frameWrapper && canvasWrapper) {
          frameWrapper.style.setProperty(
            "transform-origin",
            "center center",
            "important",
          );
          frameWrapper.style.setProperty("position", "unset", "important");

          canvasWrapper.style.setProperty("overflow", "hidden", "important");
          canvasWrapper.style.setProperty("display", "flex", "important");
          canvasWrapper.style.setProperty(
            "justify-content",
            "center",
            "important",
          );
          canvasWrapper.style.setProperty("align-items", "center", "important");
        }
      }, 50);
    }
  };

  // const getModuleList = () => {
  //   getVeevaLinkedModulesListByid(
  //     appData?.deckId?._id,
  //     (response, err, errorCode) => {
  //       if (err) {
  //       } else {
  //         const data = response?.data?.response?.content_modules || [];
  //         console.log(data, 'ggg')
  //             setContentModules(data);
  //             }
  //           }
  //     );
  // }

  const handleModuleWindow = () => {
    setSearhModuleModal(true);
    setEditModuleSelection(true);
  };

  const hideStyleManger = () => {
    editor.select(null);
    toggleLeftPanel();
    hideStructureBlock();
  };

  const hideStructureBlock = () => {
    const hideStructureBlock = document.querySelector(".gjs-blocks-c");
    hideStructureBlock?.classList.add("d-none");
    const showOtherBlock = document.querySelector(".gjs-blocks-no-cat");
    // showOtherBlock.classList.remove("d-none");
    const hideBackbutton = document.querySelector("#hideStructure");
    hideBackbutton?.classList.add("d-none");
  };

  const selectHandler = (e) => {
    if (e === "second") {
      setSelectedModule(undefined);
    }
    setActiveTab(e);
  };
  const changeEditorMode = (event) => {
    setswitchEditorMode(!switchEditorMode);
    if (!event.target.checked) {
      editor?.setDragMode("translate");
    } else {
      editor?.setDragMode("absolute");
    }
  };

  // const otherCountryStatus = ['DRAFT', 'NOT SUBMITTED'];
  // const spainCountryStatus = ['DRAFT', 'NOT SUBMITTED', 'REVIEWED WITH MINOR CHANGES','APPROVED WITH MINOR CHANGES'];
  // const ValidateStatusCriteria = (cardData) => {
  //   let docstatus = false;
  //   const countryOther = market?.find(({ _id, name }) => _id === cardData?.market && name !== "Spain");
  //   const countrySpain = market?.find(({ _id, name }) => _id === cardData?.market && name === "Spain") && brands?.find(({_id, name})=>_id === cardData?.brand && name === "Biktarvy");
  //   if (countryOther) {
  //         docstatus = otherCountryStatus?.includes(cardData?.veevaMetadata?.filter((asset) => asset?.assetType === 1)[0]?.docStatus.toUpperCase());
  //   }
  //   if (countrySpain) {
  //               docstatus = spainCountryStatus?.includes(cardData?.veevaMetadata?.filter((asset) => asset?.assetType === 1)[0]?.docStatus.toUpperCase());

  //   }
  //   return (docstatus);
  // }

  const ratioHandler = (event) => {
    setRatioMode(!ratioMode);
    if (!event.target.checked) {
      // editor?.setDragMode("off");
    } else {
      // editor?.setDragMode("on");
    }
  };

  return (
    <div className="editor-wrapper" style={{ backgroundColor: "f0f6fc" }}>
      <div className="d-flex main-header">
        <div className={`editor-wrapper-header1`}>
          <PresentationStatus
            expandDetailDrop={expandDetailDrop}
            setExpandDetailDrop={setExpandDetailDrop}
            nameDrop={nameDrop}
            expandName={expandName}
            editor={editor}
            navigate={navigate}
            flowCreator={false}
            setLoadSuccess={setLoadSuccess}
            isOTC={isOneTimeContent}
          />
        </div>
        <div style={{ flex: "0 0 1" }} className="editor-wrapper-header2">
          {/* <div className='editor-wrapper-header-content d-flex'> */}
          <div className="d-flex align-items-center">
            <div
              className="editor-wrapper-header-content1 d-flex"
              onClick={() => editor.runCommand("saveDb")}
            >
              <CustomTooltip title="Save" classes="editor-wrapper-save-popover">
                <img src={SaveChangesNewIcon} width={99} height={16} alt="" />
              </CustomTooltip>
            </div>
            <div
              className="d-flex editor-wrapper-right-border"
              style={{ marginLeft: "16px", padding: "3px 16px" }}
            >
              <div
                onClick={() => {
                  //editor.runCommand("undo");
                  undoManager();
                }}
                // title="Undo"
                className={!redoCurrentStatus ? "urDisabled" : null}
              >
                <CustomTooltip
                  title="Undo"
                  classes="editor-wrapper-undo-popover"
                >
                  <img
                    alt="undo"
                    src={UndoNewIcon}
                    width={24}
                    height={18}
                    style={{ cursor: "pointer" }}
                    className="codeEditorIcon"
                  />
                </CustomTooltip>
              </div>
              <div
                onClick={() => {
                  redoManager();
                  // editor.runCommand("redo");
                }}
                // title="Redo"
                style={{ marginLeft: "12px" }}
                className={!undoCurrentStatus ? "urDisabled" : null}
              >
                <CustomTooltip
                  title="Redo"
                  classes="editor-wrapper-redo-popover"
                >
                  <img
                    alt="redo"
                    src={RedoNewIcon}
                    style={{ width: "24px", height: "18px", cursor: "pointer" }}
                    className="codeEditorIcon editor-wrapper-common1"
                  />
                </CustomTooltip>
              </div>
              <div className="editor-custom-js-toggle mode-switch middle-pannel-header-toggle d-flex align-items-center">
                <label className="toggle-translate">Translate</label>
                {/* <Switch
                          placement="start"
                          className="toggle-switch-button"
                          // defaultChecked={false}
                          // disabled
                        /> */}
                <label class="toggle-switch-btn">
                  <input
                    type="checkbox"
                    checked={switchEditorMode}
                    name="switchToggle"
                    onClick={(event) => changeEditorMode(event)}
                  />
                  <span class="toggle-switch switch-round"></span>
                </label>
                <label className="toggle-absolute">Absolute</label>
              </div>
            </div>
          </div>
          <TopPanelIcons
            editor={editor}
            setCodeEditor={setCodeEditor}
            scaleCentPercent={scaleCentPercent}
            setScaleCentPercent={setScaleCentPercent}
            setZommedHundredPercent={setZommedHundredPercent}
            inputElement={inputElement}
            codeEditor={codeEditor}
            cardInfoHandler={cardInfoHandler}
            runValidationChecks={runValidationChecks}
            undoCurrentStatus={undoCurrentStatus}
            redoCurrentStatus={redoCurrentStatus}
            undoManager={undoManager}
            redoManager={redoManager}
            appData={appData}
            selectedItem={selectedItemRef.current}
            setSelectedItem={setSelectedItem}
            setMlrPdfLoader={setMlrPdfLoader}
            setpdfURL={setpdfURL}
            setCodeEditorLoading={setCodeEditorLoading}
            setSaveLoading={setSaveLoading}
            setDimensionVariable={setDimensionVariable}
            calculateNormalizedZoom={calculateNormalizedZoom}
            expandLeft={expandLeft}
            isOneTimeContent={isOneTimeContent}
          ></TopPanelIcons>
        </div>
      </div>
      <CircularProgressBar
        isloading={
          mlrPdfLoader ||
          exportLoading ||
          saveLoading ||
          loading ||
          flowCreatorLoading || // For flow creator
          codeEditorLoading // For code editor open and close
        }
      />
      <div className="d-flex editor-wrapper-content">
        <div
          className="left-section-partition lhs-css"
          style={{ flex: `0 0 ${expandLeft}px` }}
        >
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeTab}
            onSelect={selectHandler}
          >
            <Nav variant="pills" className="flex">
              <Nav.Item
                className={`editor-wrapper-items editor-wrapper-items-format ${
                  nameDrop?.type == 1 || isOneTimeContent
                    ? "editor-wrapper-items-template"
                    : ""
                }`}
              >
                <Nav.Link
                  eventKey="first"
                  className={`editor-wrapper-tools ${
                    nameDrop?.type !== 2
                      ? "editor-wrapper-tools-template-format"
                      : "editor-wrapper-tools-common"
                  } ${nameDrop?.type !== 2 ? "navWidth" : ""}`}
                  onClick={() =>
                    document
                      .querySelector('.gjs-block img[alt="structure"]')
                      ?.closest(".gjs-block")
                      .click()
                  }
                >
                  FORMAT
                </Nav.Link>
              </Nav.Item>
              {nameDrop?.type == 2 && !isOneTimeContent && (
                <Nav.Item
                  className={`editor-wrapper-items editor-wrapper-items-Content`}
                >
                  <Nav.Link
                    eventKey="second"
                    className={`editor-wrapper-tools  ${
                      nameDrop?.type !== 2 ? "" : "editor-wrapper-tools-common"
                    } ${nameDrop?.type !== 2 ? "navWidth" : ""}`}
                  >
                    CONTENT
                  </Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item
                className={`editor-wrapper-items editor-wrapper-items-layers ${
                  nameDrop?.type == 1 || isOneTimeContent
                    ? "editor-wrapper-items-template"
                    : ""
                }`}
              >
                <Nav.Link
                  eventKey="thrid"
                  className={`editor-wrapper-tools ${
                    nameDrop?.type !== 2
                      ? "editor-wrapper-tools-template-layers"
                      : "editor-wrapper-tools-common"
                  } ${nameDrop?.type !== 2 ? "navWidth" : ""}`}
                >
                  LAYERS
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="">
              <Tab.Pane eventKey="first" className="editor-wrapper-tab"
                onDragOver={(e) => e.preventDefault()}>
                <div className="editor-wrapper-tab-structure">
                  <div id="blocks"></div>
                </div>
                <div className="editor-wrapper-tab-content">
                  <div
                    className="editorLeftContainer"
                    style={{ width: expandLeft === 450 ? "394px" : "205px" }}
                  >
                    {toggle && !videoSelected && (
                      <div className="col-md-12 p-0 test" id="test">
                        <div className="leftPanelscrollbar MediaTabParent customScrollBar">
                          <MediaTab
                            setState={setState}
                            editor={editor}
                            hideStyleManger={hideStyleManger}
                            deckData={deckData}
                            brands={brands}
                            market={market}
                            campaign={campaign}
                            expandLeft={expandLeft}
                            setLoadSuccess={setLoadSuccess}
                          />
                        </div>
                      </div>
                    )}
                    {toggle && videoSelected && (
                      <div className="col-md-12 p-0 test" id="test">
                        <div className="leftPanelscrollbar MediaTabParent customScrollBar">
                          <VideoMediaTab
                            setState={setState}
                            editor={editor}
                            hideStyleManger={hideStyleManger}
                            deckData={deckData}
                            brands={brands}
                            market={market}
                            campaign={campaign}
                            expandLeft={expandLeft}
                            setVideoSelected={setVideoSelected}
                            localVideoList={localVideoList}
                            setLocalVideoList={setLocalVideoList}
                            localPosterList={localPosterList}
                            setLocalPosterList={setLocalPosterList}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane
                eventKey="second"
                className="editor-wrapper-tab module-tools-tabs"
              >
                {appData?.deckId?._id && (
                  <LeftContentPanel
                    activeTab={activeTab}
                    selectedModule={selectedModule}
                    setSelectedModule={setSelectedModule}
                    searhModuleModal={searhModuleModal}
                    handleModuleWindow={handleModuleWindow}
                    appData={appData}
                    customDrag={customDrag}
                    editor={editor}
                  />
                )}
              </Tab.Pane>
              <Tab.Pane
                eventKey="thrid"
                className="editor-wrapper-tab module-tools-tabs"
              >
                <div id="layerHtml"></div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
          <div
            style={{
              position: "absolute",
              width: "14px",
              height: "58px",
              top: `${window.innerHeight / 2 + 30}px`,
              left: `${expandLeft === 261 ? "3px" : "1px"}`,
              // translate: `${expandLeft === 259 ? '257px -333px' : '448px -303px'}`,
              translate: `${expandLeft === 261 ? "257px" : "448px"}`,
              zIndex: "1",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTop: "solid 1px #e6e6eb",
              borderBottom: "solid 1px #e6e6eb",
              borderRight: "solid 1px #e6e6eb",
              borderLeft: "1px solid #fff",
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
            }}
          >
            <img
              src={expandLeft === 261 ? RightIcon : LeftIcon}
              alt=""
              width={19}
              height={19}
              className="expand-left"
              onClick={() => expandRightHandler("left")}
            />
          </div>
        </div>
        <div id="canvas-container" className="editor-content-container">
          <div className="sub-canvas-container">
            {/* <div className="zoomInOut">
              <button className="resizeButton" onClick={editorZoomOut}>
                -
              </button>
              <div className="persentDisplay">{`${scaleCentPercent}%`}</div>
              <button className="resizeButton" onClick={editorZoomIn}>
                +
              </button>
              <button className="zoomReset" onClick={resetZoom}>
                Reset
              </button>
            </div> */}

            <div className="editorContainer customScrollBar">
              <div
                className="middle-pannel-header"
                style={{ background: "#fff" }}
              >
                <div className="d-flex middle-pannel-header1 d-flex justify-content-between">
                  <div className="d-flex middle-pannel-header2">
                    <div className="middle-pannel-header-icon middle-pannel-efficacy">
                      <div className="middle-pannel-flow-creator">
                        <CustomTooltip
                          title="Flow Creator"
                          classes="editor-wrapper-save-popover"
                        >
                          <img
                            src={FlowCreatorIcon}
                            width={24}
                            height={24}
                            alt=""
                            onClick={gotoReorder}
                          />
                        </CustomTooltip>
                      </div>
                    </div>
                    <div className="middle-pannel-header-content middle-pannel-efficacy">
                      {showEnterSlideNameInput ? (
                        <div className="message-input-main ">
                          <input
                            name="name"
                            className="message-input"
                            id="message-input"
                            placeholder="Enter Slide Name"
                            value={getFieldValue("name")}
                            autofocus
                            onChange={(event) =>
                              slideMessageSubmit(event, "", " Slide Name")
                            }
                            onKeyUp={(event) =>
                              slideMessageSubmit(event, "enter", " Slide Name")
                            }
                            onBlur={(event) =>
                              slideMessageSubmit(event, "blur", " Slide Name")
                            }
                            type="text"
                          />{" "}
                        </div>
                      ) : (
                        <CustomTooltip
                          title={getFieldValue("name")}
                          classes="slide-text-name"
                        >
                          <div
                            className="slideNo slide-no"
                            onClick={() => onEnterSlideKeyName("slide")}
                          >
                            {getFieldValue("name")}
                          </div>
                        </CustomTooltip>
                      )}
                    </div>
                    <div
                      className={`middle-pannel-header-content ${
                        nameDrop?.type !== 2 ? "middle-pannel-efficacy" : ""
                      }`}
                    >
                      {showEnterKeyMessageInput ? (
                        <div className="message-input-main">
                          <input
                            name="key_message"
                            className="message-input"
                            value={getFieldValue("key_message")}
                            autofocus
                            placeholder="Enter Key Message"
                            onChange={(event) =>
                              slideMessageSubmit(event, "", " Key Message")
                            }
                            // onEnter={(event) => slideMessageSubmit(event, "enter")}
                            onKeyUp={(event) =>
                              slideMessageSubmit(event, "enter", " Key Message")
                            }
                            onBlur={(event) =>
                              slideMessageSubmit(event, "blur", " Key Message")
                            }
                            type="text"
                          />{" "}
                        </div>
                      ) : (
                        <div
                          className="slideNo slide-no"
                          onClick={() => onEnterSlideKeyName("key")}
                        >
                          {getFieldValue("key_message")}
                        </div>
                      )}
                    </div>
                    {
                      // nameDrop?.type !== 2
                      false && (
                        <SwitchClassicModular
                          editor={editor}
                          currentSlideRef={currentSlideRef}
                          setSwitchToggleData={setSwitchToggleData}
                          setModCurPopup={setModCurPopup}
                          switchToggleData={switchToggleData}
                        />
                      )
                    }
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <ParentSlideNavigation
                        slideID={slideID}
                        setSlideID={setSlideID}
                        currentSlide={currentSlide}
                        setCurrentSlide={setCurrentSlide}
                        setSlideCount={setSlideCount}
                        editor={editor}
                        appData={appData}
                        childSlideCount={childSlideCount}
                        setChildSlideCount={setChildSlideCount}
                        loadSuccess={loadSuccess}
                        setLoadSuccess={setLoadSuccess}
                        setSaveLoading={setSaveLoading}
                        slideCount={slideCount}
                        slideCountDisplay={slideCountDisplay}
                        inputElement={inputElement}
                        setSlideCountDisplay={setSlideCountDisplay}
                      ></ParentSlideNavigation>
                    </div>
                    <div className="right-border-adding-slide"></div>
                    <div
                      className="adding-slide-subSlide"
                      onClick={(e) => slideHandler(e)}
                    >
                      <img
                        src={GroupNewIcon}
                        className="adding-slide-subSlide"
                        width={3.8}
                        height={16}
                        alt="Adding slide"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-Container">
                {!codeEditor && (
                  <div
                    id="gjsEditor-outterwapper"
                    ref={inputElement}
                    className="customScrollBar"
                  >
                    <div id="gjsEditor"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="right-section-partition"
          style={{ flex: `0 0 ${expandRight}px` }}
        >
          <div
            style={{
              position: "absolute",
              width: "14px",
              height: "58px",
              top: `${window.innerHeight / 2 + 30}px`,
              translate: "-14px",
              zIndex: "1",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTop: "solid 1px #e6e6eb",
              borderBottom: "solid 1px #e6e6eb",
              borderLeft: "solid 1px #e6e6eb",
              borderRight: "1px solid #fff",
              borderTopLeftRadius: "6px",
              borderBottomLeftRadius: "6px",
            }}
          >
            <img
              src={expandLeft === 261 ? RightIcon : LeftIcon}
              alt=""
              width={19}
              height={19}
              className="expand-right"
              onClick={() => expandRightHandler("right")}
            />
          </div>
          <div className="right-left-section-label">
            <h2 className="right-left-section-properties">PROPERTIES</h2>
          </div>
          <div className="propertiesBlock">
            <div id="PageManager" className=""></div>
            <div id="stylesMangerBlock" className=""></div>
            <div id="traitBlock" className="traitblockStyling"></div>
          </div>
        </div>
      </div>
      {showAllSlides && (
        <SlideSwapperLeftPanel
          editor={editor}
          setState={setState}
          showAllSlides={showAllSlides}
          showSlidesPanel={showSlidesPanel}
          appData={appData}
          setShowAllSlides={setShowAllSlides}
          getVeevaLinkedmodules={getVeevaLinkedmodules}
          setDeckData={setDeckData}
          setSlideID={setSlideID}
          setCurrentSlide={setCurrentSlide}
          swapped={swapped}
          setSlideCount={setSlideCount}
          setSwapped={setSwapped}
          slideID={slideID}
          setSaveLoading={setSaveLoading}
          setFlowCreatorLoading={setFlowCreatorLoading}
        />
      )}
      {/* {showPreview && (
        <PreviewModal
          showPreview={showPreview}
          setShowPreView={setShowPreView}
          setLoading={setLoading}
          deckData={deckData}
          slideID={slideID}
          currentSlide={currentSlide}
          lastChild={lastChild}
          inParent={inParent}
          canvasHeight={canvasHeight}
          appData={appData}
          previewUrlReady={true}
        />
      )} */}
       {showPreview && (
        <NewPreviewModal
          showPreview={showPreview}
          setShowPreView={setShowPreView}
          setLoading={setLoading}
          deckData={deckData}
          slideID={slideID}
          currentSlide={currentSlide}
          lastChild={lastChild}
          inParent={inParent}
          canvasHeight={canvasHeight}
          appData={appData}
          previewUrlReady={true}
        />
      )}
      {/* <CustomModal
        displayModal={searhModuleModal}
        hideModal={() => {
          handleSearchModalHide();
        }}
        title={""}
        size="xl"
        dilogClassName=""
        keyboard={false}
        openExportModal={openExportModal}
        fullscreen={true}
      > 
        <ContentModuleModal
          handleSearchModalHide={handleSearchModalHide}
          brands={brands}
          market={market}
          campaign={campaign}
          deckData={deckData}
          setCampaignName={setCampaignName}
          setSearhModuleModal={setSearhModuleModal}
          campaignName={campaignName}
          currentSlide={currentSlide}
          setVeevaModule={setVeevaModule}
          veevaModule={veevaModule}
          setVeevaContentData={setVeevaContentData}
          veevaContentData={veevaContentData}
          getVeevaModuleCardinfo={getVeevaModuleCardinfo}
          isEditModuleList={isEditModuleList}
          setIsEditModuleList={setIsEditModuleList}
          // getVeevaLinkedModulesList={getVeevaLinkedModulesList}
          setVeevaModuleSearchText={setVeevaModuleSearchText}
          veevaModuleSearchText={veevaModuleSearchText}
          searchParameters={searchParameters}
          setEditCautionbtn={setEditCautionbtn}
          editCautionbtn={editCautionbtn}
          setVeevaModuleCategory={setVeevaModuleCategory}
          veevaModuleCategory={veevaModuleCategory}
          searchedText={searchedText}
          setSearchedText={setSearchedText}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          setModuleList={setModuleList}
          moduleList={moduleList}
          userSelctedModuleList={userSelctedModuleList}
          setUserSelctedModuleList={setUserSelctedModuleList}
          linkedSearchExpression={linkedSearchExpression}
          setlinkedSearchExpression={setlinkedSearchExpression}
          getVeevaLinkedmodules={getVeevaLinkedmodules}
          slideID={currentSlideRef.current}
          setLinkedModule={setLinkedModule}
        />
        </CustomModal> */}
      <Module
        displayModal={searhModuleModal}
        hideModal={() => {
          handleSearchModalHide();
        }}
        size="xl"
        keyboard={false}
        handleSearchModalHide={handleSearchModalHide}
        brands={brands}
        market={market}
        setSearhModuleModal={setSearhModuleModal}
        veevaModule={veevaModule}
        setVeevaContentData={setVeevaContentData}
        getVeevaModuleCardinfo={getVeevaModuleCardinfo}
        isEditModuleList={isEditModuleList}
        searchedText={searchedText}
        selectedCategory={selectedCategory}
        setlinkedSearchExpression={setlinkedSearchExpression}
        getVeevaLinkedmodules={getVeevaLinkedmodules}
        slideID={currentSlideRef.current}
        setLinkedModule={setLinkedModule}
        editModuleSelection={editModuleSelection}
        setEditModuleSelection={setEditModuleSelection}
        selectedModule={selectedModule}
        hasFetched={hasFetched}
        setHasFetched={setHasFetched}
      />
      {selectNextModal && (
        <CustomModal
          displayModal={selectNextModal}
          hideModal={() => {
            handleSelectNextModalHide();
          }}
          title={""}
          size="xl"
          dilogClassName={`select-next-modal ${
            showAssociateModal ? "hideModal" : "showModal"
          }`}
          keyboard={false}
          // openExportModal={openExportModal}
        >
          <NextContentModuleModal
            handleSelectNextModalShow={handleSelectNextModalShow}
            handleSelectNextModalHide={handleSelectNextModalHide}
            deckData={deckData}
            brands={brands}
            market={market}
            campaign={campaign}
            categoryList={categoryList}
            getVeevaLinkedmodules={getVeevaLinkedmodules}
            slideID={currentSlideRef.current}
            setShowAssociateModal={setShowAssociateModal}
            showAssociateModal={showAssociateModal}
            setContentModules={setContentModules}
            contentModules={contentModules}
            linkedMMModules={linkedMMModules}
            setLinkedMMModules={setLinkedMMModules}
            setLinkedModule={setLinkedModule}
            linkedSearchExpression={linkedSearchExpression}
          />
        </CustomModal>
      )}
      {openExportModal && (
        <CustomModal
          displayModal={openExportModal}
          hideModal={() => {
            closeExportModal();
          }}
          title={""}
          size="sm"
          dilogClassName="alertModalSmall"
          keyboard={false}
          openExportModal={openExportModal}
        >
          <ExportTemplate
            handleExportModal={handleExportModal}
            closeExportModal={closeExportModal}
            openExportModal={openExportModal}
            // cardData={showTemplateRes}
            exportFormats={exportFormats}
            setExportFormats={setExportFormats}
            handleExport={handleExport}
          />
        </CustomModal>
      )}
      {openMLRPDF && (
        <div>
          <CustomModal
            fullscreen={true}
            displayModal={openMLRPDF}
            hideModal={() => {
              closeExportModal();
            }}
            title={""}
            size="xl"
            dilogClassName="MLRPDF"
            keyboard={false}
            openExportModal={openMLRPDF}
          >
            <MLRPDF
              pdfURL={pdfURL}
              handleExportModal={handleExportModal}
              closeExportModal={closeExportModal}
              openMLRPDF={openMLRPDF}
              setOpenMLRPDF={setOpenMLRPDF}
              handleExport={handleExport}
              deckData={deckData}
              SetShowPdfPreview={setOpenMLRPDF}
              setOpenExportModal={setOpenExportModal}
            />
          </CustomModal>
        </div>
      )}
      {openDocumentModal && (
        <UploadDocument
          openDocumentModal={openDocumentModal}
          setOpenDocumentModal={setOpenDocumentModal}
          deckId={appData?.deckId?._id}
          editor={editor}
        />
      )}
      {/* {codeEditor && (
        <CodeEditor
          editor={editor}
          codeEditor={codeEditor}
          setCodeEditor={setCodeEditor}
          appData={appData}
          currentSlideRef={currentSlideRef}
          localScripts={localScripts}
          setLocalScripts={setLocalScripts}
          nameDrop={nameDrop}
          cardInfoHandler={cardInfoHandler}
        />
      )} */}
      {codeEditor && (
        <NewCodeEditor
          editor={editor}
          codeEditor={codeEditor}
          setCodeEditor={setCodeEditor}
          appData={appData}
          currentSlideRef={currentSlideRef}
          localScripts={localScripts}
          setLocalScripts={setLocalScripts}
          nameDrop={nameDrop}
          cardInfoHandler={cardInfoHandler}
          inputElement={inputElementCode}
          callEditor={callEditor}
          setCodeEditorSave={setCodeEditorSave}
          setCodeEditorLoading={setCodeEditorLoading}
        />
      )}
      {openCardDetailsModal && (
        <CustomModal
          displayModal={openCardDetailsModal}
          // hideModal={() => {
          //   closeExportModal();
          // }}
          title={""}
          size="lg"
          // style={{height: "577px !important"}}
          dilogClassName="detail-informations-modal"
          keyboard={false}
          openCardDetailsModal={openCardDetailsModal}
        >
          <DetailsInformationsModal
            mode="edit"
            nameDrop={nameDrop}
            // setOpenCardDetailsModal={setOpenCardDetailsModal}
            setNameDrop={setNameDrop}
            closeCardDetailsModal={closeCardDetailsModal}
            cardInformation={cardInformation}
            deckId={appData?.deckId?._id}
            templateType={appData?.deckId?.type === 1 ? "template" : "edetail"}
            setCardInformation={setCardInformation}
            countriesList={market}
            brands={brands}
          />
        </CustomModal>
      )}

      {openRunValidationChecksModal && (
        <RunValidationChecksModal
          isOpenRunValidationChecksModal={openRunValidationChecksModal}
          setOpenRunValidationChecksModal={setOpenRunValidationChecksModal}
          runValidationChecksReportData={runValidationChecksReportData}
        ></RunValidationChecksModal>
      )}
      {openPopover && (
        <div
          className="editor-wrapper-popover"
          style={{ top: popoverAxis.top, left: popoverAxis.left }}
        >
          <ul>
            <li className="ignoreClick">
              <SlideIndex
                setOpenPopover={setOpenPopover}
                editor={editor}
                slideCount={slideCount}
                setSlideCount={setSlideCount}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                slideID={slideID}
                setSlideID={setSlideID}
                slideNameCount={slideNameCount}
                setSlideNameCount={setSlideNameCount}
                geteDetailByID={geteDetailByID}
                childSlideCount={childSlideCount}
                setChildSlideCount={setChildSlideCount}
                inputElement={inputElement}
                setcanvasWidth={setcanvasWidth}
                loadSuccess={loadSuccess}
                setLoadSuccess={setLoadSuccess}
                setSaveLoading={setSaveLoading}
              />
            </li>
            {/* <li className="ignoreClick">
              <SubSlide
                setOpenPopover={setOpenPopover}
                slideID={slideID}
                setSlideID={setSlideID}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                editor={editor}
                appData={appData}
                slideCount={slideCount}
                childSlideCount={childSlideCount}
                setChildSlideCount={setChildSlideCount}
                navigate={navigate}
                loadSuccess={loadSuccess}
                setLoadSuccess={setLoadSuccess}
                setSaveLoading={setSaveLoading}
              />
            </li> */}
            {JSON.stringify(currentSlide?.child) === "{}" && (
              <li className="ignoreClick">
                <CloneSlideTemplate
                  currentSlide={currentSlide}
                  setCurrentSlide={setCurrentSlide}
                  setSlideCountDisplay={setSlideCountDisplay}
                  setSlideNameCount={setSlideNameCount}
                  slideNameCount={slideNameCount}
                  slideID={slideID}
                  setSlideCount={setSlideCount}
                  setSlideID={setSlideID}
                  appData={appData}
                  setCloneLoading={setCloneLoading}
                  deckName={nameDrop?.name}
                />
              </li>
            )}
            <li className="ignoreClick">
              <ClearSlide editor={editor}  appData={appData} />
            </li>
            <li className="ignoreClick">
              <SlideNextAndPrevious
                slideID={slideID}
                setSlideID={setSlideID}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                setSlideCount={setSlideCount}
                editor={editor}
                appData={appData}
                childSlideCount={childSlideCount}
                setChildSlideCount={setChildSlideCount}
                loadSuccess={loadSuccess}
                setLoadSuccess={setLoadSuccess}
                setSaveLoading={setSaveLoading}
                slideCount={slideCount}
              ></SlideNextAndPrevious>
              {/* <img src={DeleteNewIcon} alt="" />
              <h2>Delete</h2> */}
            </li>
            <li
              className="ignoreClick"
              onClick={() => {
                getAppData();
                setOpenSharedResource(true);
              }}
            >
              <img
                src={EditSharedIcon}
                alt="Edit Shared Resources"
                class="ignoreClick"
              />
              <h2>Edit Shared Resources</h2>
            </li>
          </ul>
        </div>
      )}
      {modCurPopup && (
        <RevertBackSmartTemp
          modCurPopup={modCurPopup}
          setModCurPopup={setModCurPopup}
          setSwitchToggleData={setSwitchToggleData}
          editor={editor}
          currentSlide={currentSlide}
        />
      )}
      {referenceBetween && (
        <ReferenceWarning
          referenceBetween={referenceBetween}
          setReferenceBetween={setReferenceBetween}
          addReferenceBlock={addReferenceBlock}
          setAddReferenceBlock={setAddReferenceBlock}
          editor={editor}
        />
      )}
      {uploadFont && (
        <FontUploadLayout
          uploadFont={uploadFont}
          setUploadFont={setUploadFont}
          deckId={appData?.deckId?._id}
          editor={editor}
        />
      )}
      {openSharedResource && (
        <SharedResource
          modeFrom="Edit"
          editor={editor}
          deckIdCurrent={appData?.deckId}
          isOpenSharedModal={openSharedResource}
          sourceDeckId={appData?.deckId?.based_on || ""}
          setOpenSharedResource={setOpenSharedResource}
          hideModal={() => {
            // closeExpireTemplateModal();
          }}
          title={""}
          size="lg"
          dilogClassName="expire-template-modal"
          keyboard={false}
        ></SharedResource>
      )}
      {/* {editorHeightToast && showSuccessToast("Ensure all content stays within the designated wrapper. Avoid exceeding the editor's height to maintain design consistency.")} */}
    </div>
  );
};

export default Editor;
